export const SENTRY_LARAVEL_DSN = import.meta.env.VITE_SENTRY_LARAVEL_DSN;
export const SENTRY_TRACES_SAMPLE_RATE = import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE;
export const APP_ENV = import.meta.env.VITE_APP_ENV;
export const SENTRY_RELEASE = import.meta.env.VITE_SENTRY_RELEASE;
export const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
export const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST;

// The young person a Parent last chose, kept in localStorage by `Parent/YoungPersonProvider`.
// Every logout forgets it (COM-457): the three applications share one origin, so whoever
// signs in next on the same browser, in any role, would otherwise find it.
export const SELECTED_YOUNG_PERSON_KEY = 'selectedYoungPersonID';
